import React from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';

interface FallbackProps {
  message?: string;
}

export const fallback: React.FC<FallbackProps> = ({
  message = 'Loading...',
}) => {
  return (
    <Box
      display="flex"
      minHeight="100vh"
      bg="gray.50"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap="4"
      >
        {/* @ts-expect-error - Chakra UI 1.8.9 Spinner type issue */}
        <Spinner
          size="xl"
          thickness="4px"
          speed="0.65s"
          color="green.500"
        />
        <Text fontSize="lg" color="gray.700" fontWeight="medium">
          {message}
        </Text>
      </Box>
    </Box>
  );
};
